<template>
    <div class="modal fade" id="modal-confirm" >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="p-3">{{ message }}</p>

                    <hr>
                    
                    <div class="d-flex flex-row-reverse">
                        <button class="btn btn-sm btn-light" @click="result(1)">Sim</button>
                        <button class="btn btn-sm btn-light" @click="result(0)">Não</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'modal-confirm',
        props: [ 'message', 'response' ],

        methods: {
            result(payload) {
                this.$emit('response', payload)
                $("#modal-confirm").modal('hide')
            },
        }
    }
</script>